import { createSlice } from "@reduxjs/toolkit";
import adminThunkActions from "./thunk/adminThunk";
import extraReducers from "./thunk/adminExtraReducers";

export const ADMIN_FLOW_SLICE_NAME = "adminFlow";

const initialState = {
  fileUploadType: {
    data: [],
    error: null,
  },
  globalRoleList: {
    data: [],
    error: null,
  },
  roleList: {
    data: [],
    error: null,
  },
  filterList: {
    data: [],
    error: null,
  },
  verticalList: {
    data: [],
    error: null,
  },
  userSearch: {
    data: [],
    error: null,
  },
  reportFilterList: {
    data: [],
    error: null,
  },
  filterValueOptions: {
    data: [],
    error: null,
  },
  childFilterValueOptions: {
    data: [],
    error: null,
  },
  reportList: {
    data: [],
    error: null,
  },
  entityTypeList: {
    data: [],
    error: null,
  },
  filterValueList: {
    data: [],
    error: null,
  },
};

export const adminFlowSlice = createSlice({
  name: ADMIN_FLOW_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers,
});

export const adminActions = {
  ...adminFlowSlice.actions,
  ...adminThunkActions,
};

export default adminFlowSlice.reducer;
